import React from 'react';
import type { IconBaseProps, IconType } from 'react-icons';

type IconProps = {
  icon: IconType;
  className?: string;
  style?: React.CSSProperties;
} & React.HTMLAttributes<SVGElement>; // allow data-testid, aria-label, etc.

export default function Icon({ icon, className, style, ...rest }: IconProps) {
  const IconComponent = icon as unknown as React.FC<IconBaseProps>;
  return <IconComponent className={className} style={style} {...rest} />;
}
